import React, { Component } from "react";
import { Field, reduxForm } from "redux-form";
import { required, number, fieldLength4 } from "../../utils/formValidators";
import { renderField } from "../../utils/renderField";

export class SSNValidationComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSSN: true,
    };

    this.submitForm = this.submitForm.bind(this);
    this.toggleSSNVisibility = this.toggleSSNVisibility.bind(this);
  }

  submitForm(values) {
    this.props.submitForm(this.props.form);
  }

  toggleSSNVisibility() {
    this.setState({ showSSN: !this.state.showSSN });
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit(this.submitForm)}>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Field
                id="taxIdLast4"
                component={renderField}
                label="Please enter the last four digits of the primary applicant's social security number."
                name="taxIdLast4"
                validate={[number, fieldLength4, required]}
                type={this.state.showSSN ? "text" : "password"}
                inputMode="numeric"
                hasOtherIcon={true}
                showHideOnClick={this.toggleSSNVisibility}
                showHideIcon={this.state.showSSN}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <button type="submit" class="button primary">
                Continue
              </button>
            </div>
          </div>
        </div>
      </form>
    );
  }
}

//Connect to Redux store
const SSNValidation = reduxForm({ form: "SSNValidation" })(SSNValidationComponent);

export default SSNValidation;



// WEBPACK FOOTER //
// ./src/pages/home-equity-appraisal/ssn-validation-form.js